import {
  Box,
  Grid,
  Typography,
  Switch,
  TableContainer,
  Table,
  TableBody,
} from "@mui/material";
import { WhatsappNotificationConfiguration } from "../types";
import { useState } from "react";
import CardBox from "../../../main/components/CardBox";
import PrimaryBaseButton from "../../../main/components/PrimaryBaseButton";
import DangerBaseButton from "../../../main/components/DangerBaseButton";
import ConfirmationDialogUser from "./ConfirmationDialogUser";
import { ConfirmationModal } from "../../../main/components/ConfirmationModal";
import { ActionAlert } from "../../../main/components/alerts/ActionAlert";
import { usersApi } from "../../../services/api";
import UserWhatsappConfigurationToggle from "./UserWhatsappConfigurationToggle";

export function UserDetailsWhatsappToggleItems(props: {
  clientId: string;
  whatsAppConfiguration: WhatsappNotificationConfiguration;
  setWhatsappConfiguration: React.Dispatch<
    React.SetStateAction<WhatsappNotificationConfiguration | undefined>
  >;
  label: string;
  defaultWhatsappConfiguration: WhatsappNotificationConfiguration | undefined;
  userEmail: string;
  onMount: () => void;
}) {
  const {
    clientId,
    whatsAppConfiguration,
    label,
    setWhatsappConfiguration,
    defaultWhatsappConfiguration,
    userEmail,
    onMount,
  } = props;

  const [isCancelConfirmationOpen, setCancelConfirmationOpen] =
    useState<boolean>(false);
  const handleConfirmCancel = () => {
    setWhatsappConfiguration(defaultWhatsappConfiguration);
    setCancelConfirmationOpen(false);
  };
  const [isSaveConfirmationOpen, setSaveConfirmationOpen] =
    useState<boolean>(false);
  const [openSuccessModal, setOpenSuccessModal] = useState<boolean>(false);
  const [openErrorModal, setOpenErrorModal] = useState<boolean>(false);
  const handleConfirmSave = async () => {
    try {
      await usersApi.updateWhatsappNotificationConfiguration(
        userEmail,
        clientId,
        whatsAppConfiguration
      );
      setSaveConfirmationOpen(false);
      setOpenSuccessModal(true);
    } catch (error) {
      setOpenErrorModal(true);
    }
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        width: "100%",
        columnGap: "10px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          columnGap: "10px",
          alignItems: "center",
          width: "100%",
          justifyContent: "space-between",
        }}
      >
        <Typography
          sx={{
            fontWeight: 500,
            fontSize: "16px",
          }}
        >
          {label}
        </Typography>
        <Box
          sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
        >
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: "14px",
            }}
          >
            {whatsAppConfiguration.whatsappNotificationsEnabled
              ? "Desabilitar Notificações de whatsapp"
              : "Habilitar Notificações de whatsapp"}
          </Typography>
          <Switch
            checked={whatsAppConfiguration.whatsappNotificationsEnabled}
            onChange={(_, checked) =>
              setWhatsappConfiguration({
                ...whatsAppConfiguration,
                whatsappNotificationsEnabled: checked,
              })
            }
            inputProps={{ "aria-label": "controlled" }}
          />
        </Box>
      </Box>
      <Grid
        container
        sx={{
          display: "flex",
          rowGap: "20px",
          width: "100%",
          marginTop: "15px",
        }}
      >
        <CardBox
          sx={{
            width: "100%",
            height: "200px",
            maxHeight: "200px",
            overflow: "auto",
          }}
        >
          <TableContainer
            sx={{ display: "flex", alignItems: "flex-start", height: "100%" }}
          >
            <Table size="small" stickyHeader>
              <TableBody>
                <UserWhatsappConfigurationToggle
                  disabled={!whatsAppConfiguration.whatsappNotificationsEnabled}
                  whatsappConfigurationType={
                    whatsAppConfiguration.reportMonthlyConfiguration
                  }
                  whatsappConfigurationName="reportMonthlyConfiguration"
                  whatsappConfiguration={whatsAppConfiguration}
                  setWhatsappConfiguration={setWhatsappConfiguration}
                  title="Relatório Mensal"
                />
                <UserWhatsappConfigurationToggle
                  disabled={!whatsAppConfiguration.whatsappNotificationsEnabled}
                  whatsappConfigurationType={
                    whatsAppConfiguration.reportDailyConfiguration
                  }
                  whatsappConfigurationName="reportDailyConfiguration"
                  whatsappConfiguration={whatsAppConfiguration}
                  setWhatsappConfiguration={setWhatsappConfiguration}
                  title="Boletim Diário"
                />
                <UserWhatsappConfigurationToggle
                  disabled={!whatsAppConfiguration.whatsappNotificationsEnabled}
                  whatsappConfigurationType={
                    whatsAppConfiguration.reportPartialConfiguration
                  }
                  whatsappConfigurationName="reportPartialConfiguration"
                  whatsappConfiguration={whatsAppConfiguration}
                  setWhatsappConfiguration={setWhatsappConfiguration}
                  title="Relatório Parcial"
                />
                <UserWhatsappConfigurationToggle
                  disabled={!whatsAppConfiguration.whatsappNotificationsEnabled}
                  whatsappConfigurationType={
                    whatsAppConfiguration.alarmsBlandConfiguration
                  }
                  whatsappConfigurationName="alarmsBlandConfiguration"
                  whatsappConfiguration={whatsAppConfiguration}
                  setWhatsappConfiguration={setWhatsappConfiguration}
                  title="Alarmes Leves"
                />

                <UserWhatsappConfigurationToggle
                  disabled={!whatsAppConfiguration.whatsappNotificationsEnabled}
                  whatsappConfigurationType={
                    whatsAppConfiguration.alarmsMediumConfiguration
                  }
                  whatsappConfigurationName="alarmsMediumConfiguration"
                  whatsappConfiguration={whatsAppConfiguration}
                  setWhatsappConfiguration={setWhatsappConfiguration}
                  title="Alarmes Médios"
                />
                <UserWhatsappConfigurationToggle
                  disabled={!whatsAppConfiguration.whatsappNotificationsEnabled}
                  whatsappConfigurationType={
                    whatsAppConfiguration.alarmsSevereConfiguration
                  }
                  whatsappConfigurationName="alarmsSevereConfiguration"
                  whatsappConfiguration={whatsAppConfiguration}
                  setWhatsappConfiguration={setWhatsappConfiguration}
                  title="Alarmes Severos"
                />
              </TableBody>
            </Table>
          </TableContainer>
        </CardBox>
      </Grid>
      {JSON.stringify(defaultWhatsappConfiguration) !==
        JSON.stringify(whatsAppConfiguration) && (
          <Grid
            sx={{
              paddingTop: "8px",
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
            }}
            item
            xs={12}
          >
            <DangerBaseButton
              onClick={() => setCancelConfirmationOpen(true)}
              title="Descartar"
              sx={{ height: "35px", marginRight: "8px" }}
            />
            <PrimaryBaseButton
              title="Salvar"
              onClick={() => setSaveConfirmationOpen(true)}
              sx={{ height: "35px" }}
            />
          </Grid>
        )}
      <ConfirmationDialogUser
        open={isCancelConfirmationOpen}
        title="Descartar alteração"
        message="Deseja descartar as alterações?"
        onConfirm={handleConfirmCancel}
        onCancel={() => setCancelConfirmationOpen(false)}
        onClose={() => setCancelConfirmationOpen(false)}
      />
      <ConfirmationModal
        open={isSaveConfirmationOpen}
        setOpen={() => setSaveConfirmationOpen(false)}
        title="Salvar Notificações de whatsapp"
        contentText="Deseja confirmar a edição das notificações de whatsapp?"
        onConfirm={handleConfirmSave}
      />

      <ActionAlert
        message="As notificações de whatsapp foram atualizados com sucesso!"
        severity="success"
        open={openSuccessModal}
        setOpen={() => setOpenSuccessModal(false)}
        onClose={onMount}
      />
      <ActionAlert
        message="Ocorreu um erro no modo de edição! Tente novamente mais tarde."
        severity="error"
        open={openErrorModal}
        setOpen={setOpenErrorModal}
      />
    </Box>
  );
}
